import React from 'react'
import { Post } from '@/payload-types'
import { RichText } from '@payloadcms/richtext-lexical/react'

interface PostDetailProps {
  post: Post
}

function PostDetail({ post }: Readonly<PostDetailProps>) {
  return (
    <article className="max-w-4xl mx-auto p-4">
      {post.content && <RichText data={post.content} className="prose prose-neutral" />}
    </article>
  )
}

export { PostDetail }
